import React from 'react'
import { View, TouchableOpacity, StyleSheet, Text } from 'react-native'
import { ShowDropdownIcon } from '../../../../../../assets/icons'

interface PaymentMethodFieldProps {
  label: string
  value?: string
  required?: boolean
  onPress?: () => void
  disabled?: boolean
}

export const PaymentMethodField: React.FC<PaymentMethodFieldProps> = ({
  label,
  value,
  required = false,
  onPress,
  disabled = false,
}) => {
  return (
    <View style={styles.container}>
      <Text style={styles.label}>
        {label}
        {required && <Text style={styles.required}> *</Text>}
      </Text>
      <TouchableOpacity
        style={[styles.field, disabled && styles.fieldDisabled]}
        onPress={onPress}
        disabled={disabled}
      >
        <Text
          style={[styles.value, !value && styles.placeholder]}
          numberOfLines={1}
        >
          {value || 'Select payment method'}
        </Text>
        <ShowDropdownIcon color={disabled ? '#A3B3BE' : '#082131'} />
      </TouchableOpacity>
    </View>
  )
}

const styles = StyleSheet.create({
  container: {
    marginBottom: 5,
  },
  label: {
    fontSize: 12,
    lineHeight: 16,
    color: '#001929',
    marginBottom: 3,
    fontWeight: '400',
    fontFamily: 'Inter',
  },
  required: {
    color: '#EC002A',
  },
  field: {
    height: 44,
    borderRadius: 4,
    borderWidth: 1,
    borderColor: '#99ADBA',
    backgroundColor: '#FFFFFF',
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 16,
    justifyContent: 'space-between',
  },
  fieldDisabled: {
    backgroundColor: '#F5F7F8',
    borderColor: '#99ADBA',
  },
  value: {
    flex: 1,
    fontSize: 14,
    lineHeight: 16,
    fontWeight: '600',
    fontFamily: 'Inter',
    color: '#001929',
    marginRight: 8,
  },
  placeholder: {
    color: '#6B7C8A',
  },
})
